























































































































































































































































































import { collapseMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import {GeekItem, ActivityType, ActivityGroup, WaitingActivityRequests, TranslatedActivityType} from '@/models';
import {
  AllGeeksSingleSelect,
  ConfirmActivityRequestModal,
  RejectActivityRequestModal,
  RedirectActivityRequestModal } from '@/components';
import { Multiselect } from 'vue-multiselect';
import { Actions, typedStore } from '@/store';
import { buildGeekName } from '@/utils';
import {debounce} from 'lodash';

export default mixins(collapseMixin).extend({
  name: 'WaitingActivitiesTabs',
  components: {
    AllGeeksSingleSelect,
    Multiselect,
    ConfirmActivityRequestModal,
    RejectActivityRequestModal,
    RedirectActivityRequestModal,
  },
  data() {
    return {
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        ordered: 'log-icon-pending',
        confirmed: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      filters: {
        immediate: {
          requestedForId: (null as unknown) as string,
          requestedById: (null as unknown) as string,
          activityTypeId: (null as unknown) as number,
          reason: (null as unknown) as string,
        },
      },
      activityType: (null as unknown) as ActivityType,
      confirmedActivityRequest: (null as unknown) as WaitingActivityRequests,
      rejectedActivityRequest: (null as unknown) as WaitingActivityRequests,
      redirectedActivityRequest: (null as unknown) as WaitingActivityRequests,
      loader: {
        isActivityHistoryPending: false,
      },
    };
  },
  async mounted() {
    await this.fetchAllActivities();
    await this.fetchWaitingActivityRequests();
  },
  computed: {
    collapsibleItems(): WaitingActivityRequests[] {
      return this.sortByDate(this.activityWaitingRequestItems);
    },
    activityWaitingRequestItems(): WaitingActivityRequests[] {
      return typedStore(this).state.activities.waitingRequests;
    },
    activities(): ActivityGroup[] {
      return typedStore(this).state.activities.all.map(activityGroup => {
        return {
          skill: activityGroup.skill,
          activityTypes: activityGroup.activityTypes.map(activityType => {
            return {
              ...activityType,
              translatedName: this.$t(`activity.types.${activityType.name}.name`),
            } as TranslatedActivityType;
          }),
        } as ActivityGroup;
      });
    },
  },
  methods: {
    async fetchAllActivities(): Promise<void> {
      try {
        await this.$store.dispatch(Actions.activities.fetchAll);
      } finally {
        // ignored
      }
    },
    async fetchWaitingActivityRequests(): Promise<void> {
      this.loader.isActivityHistoryPending = true;

      try {
        await this.$store.dispatch(Actions.activities.fetchWaitingActivityRequests, this.filters.immediate);
      } finally {
        this.loader.isActivityHistoryPending = false;
        this.openAllItems();
      }
    },
    updateRequestedFor(selectedGeek: GeekItem) {
      this.filters.immediate.requestedForId = selectedGeek ? selectedGeek.id : ((null as unknown) as string);
    },
    updateRequestBy(selectedGeek: GeekItem) {
      this.filters.immediate.requestedById = selectedGeek ? selectedGeek.id : ((null as unknown) as string);
    },
    updateActivity(selectedActivity: ActivityType) {
      this.activityType = selectedActivity;
      this.filters.immediate.activityTypeId = selectedActivity ? selectedActivity.id : ((null as unknown) as number);
    },
    getFullName(geek: GeekItem): string {
      return buildGeekName(geek);
    },
    isSubType(activity: WaitingActivityRequests): number {
      return activity.subtypes ? activity.subtypes.rewardGxp : activity.activity.gxp;
    },
    clearSelectedActivityType() {
      this.activityType = (null as unknown) as ActivityType;
      this.filters.immediate.activityTypeId = ((null as unknown) as number);
    },
    confirmWaitingActivityRequest(waitingRequest: WaitingActivityRequests) {
      this.confirmedActivityRequest = waitingRequest;
      this.$bvModal.show('confirm-activity-modal');
    },
    rejectWaitingActivityRequest(waitingRequest: WaitingActivityRequests) {
      this.rejectedActivityRequest = waitingRequest;
      this.$bvModal.show('reject-activity-modal');
    },
    redirectWaitingActivityRequest(waitingRequest: WaitingActivityRequests) {
      if (waitingRequest.redirectionRecipient) {
        return;
      }

      this.redirectedActivityRequest = waitingRequest;
      this.$bvModal.show('redirect-activity-modal');
    },
    sortByDate(items: WaitingActivityRequests[]) {
      return items.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    },
    updateReasonSearch: debounce(function(this: any) {
      this.filters.immediate.reason = this.$refs.searchReason.$el.value;
    }, 1000),
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchWaitingActivityRequests();
      },
      deep: true,
    },
  },
});
